const e = {
  code: "fr",
  facebook: "fr_FR",
  label: "Français",
  loadingText: "Chargement...",
  translations: {
    ar: "Arabe",
    de: "Allemand",
    en: "Anglais",
    es: "Espagnol",
    fr: "Français",
    he: "Hébreu",
    hi: "Hindi",
    id: "Indonésienne",
    it: "Italien",
    ja: "Japonais",
    km: "Khmer",
    ko: "Coréen",
    lo: "Lao",
    ms: "Malaise",
    nl: "Néerlandais",
    pt: "Portugaise",
    ru: "Russe",
    th: "Thai",
    tl: "Philippine",
    tr: "Turque",
    vi: "Vietnamienne",
    "zh-CN": "Chinois (Simp.)",
    "zh-TW": "Chinois (Trad.)"
  }
};
export {
  e as french
};
